export default ({ dropdown }) => ({
  error: {},
  dark: {},
  disabled: {},
  selectFieldWrapper: {
    '&$error': {
      '&$dark': {
        borderColor: dropdown.dark.errorBorderColor
      },
      borderColor: dropdown.error.borderColor
    },
    '&$dark': {
      backgroundColor: dropdown.dark.background
    },
    border: `1px solid ${dropdown.border}`,
    borderRadius: 3,
    width: '100%',
    backgroundColor: dropdown.background
  },
  input: {
    '&$dark': {
      '&:focus': {
        outlineColor: dropdown.dark.darkFocusColor
      },
      color: dropdown.dark.text
    },
    '&$disabled': {
      backgroundColor: dropdown.disabledBg,
      color: dropdown.disabledText
    },
    border: 'none',
    background: 'transparent',
    boxSizing: 'border-box',
    color: dropdown.text,
    display: 'block',
    fontFamily: dropdown.fontFamily,
    fontSize: 14,
    height: 34,
    marginRight: -40,
    fontWeight: dropdown.fontWeight,
    padding: [8, 40, 8, 16],
    paddingRight: 40,
    textareaHeight: 60,
    textAlign: 'left',
    width: '100%',
    position: 'relative',
    '&:focus': {
      outlineColor: dropdown.focusColor
    }
  },
  selection: {
    '&$dark': {
      color: dropdown.dark.placeholderColor
    },
    position: 'absolute',
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: 'calc(100% - 40px)',
    textAlign: 'left',
    padding: [3, 0, 7, 16],
    color: dropdown.placeholderColor
  },
  groupLabel: {
    padding: [2, 10, 4, 10],
    height: 50
  },
  fitParentWidth: {
    display: 'inline-block',
    width: '100%',
    whiteSpace: 'normal'
  },
  caret: {
    '&$dark': {
      '& svg': {
        fill: dropdown.dark.iconFill
      }
    },
    '&disabled': {
      display: 'none'
    },
    position: 'absolute',
    right: 14,
    top: 11,
    '& svg': {
      height: 12,
      width: 12,
      display: 'inherit',
      fill: dropdown.iconFill
    }
  },
  toggle: {
    border: '0',
    background: 'transparent',
    width: 34,
    height: 34,
    position: 'absolute',
    top: 19,
    right: 3
  },
  screenReaderLabel: {
    top: -1
  }
});
